import * as React from 'react';
import { usePermissions } from 'react-admin';
import { Paper } from '@material-ui/core';
import { MaterialTable } from '~/components';
import * as hb from '~/types/Handbook';
import { validateUnique, createHelperText } from './utils';
import Localizations from './Localizations';
import LocalizationAutocomplete from './LocalizationAutocomplete';

const LocalizationTable = ({
  handbook,
  setState,
}: {
  handbook: Partial<hb.Handbook>;
  setState: hb.SetState;
}) => {
  const allLocalizations = Localizations;
  const localizations: hb.GenericRecord[] = (handbook.localizations || []).slice();

  const { permissions } = usePermissions();
  if (!permissions) return null;

  return (
    <MaterialTable
      columns={[
        {
          title: 'Localization',
          field: 'id',
          required: true,
          validate: validateUnique(localizations, 'id', true),
          render: (rowData: hb.GenericRecord) => (
            <>
              {allLocalizations[rowData.id]} ({rowData.id})
            </>
          ),
          width: 400,
        },
      ]}
      components={{
        Container: (props: any) => <Paper variant='outlined'>{props.children}</Paper>,
        EditField: (props: any) => {
          const errorMessage = props.columnDef.validate
            ? props.columnDef.validate(props.rowData)
            : null;
          const helperText = createHelperText(errorMessage);
          return (
            <LocalizationAutocomplete
              value={props.value || ''}
              label={props.columnDef.title}
              onChange={(event) => {
                props.onChange(event.target.value);
              }}
              required={props.columnDef.required}
              helperText={helperText}
              error={errorMessage.length > 0}
            />
          );
        },
      }}
      data={localizations}
      editable={
        permissions?.includes('solution.handbook.update') && {
          onRowAdd: (newRecord: hb.GenericRecord) => {
            newRecord.name = allLocalizations[newRecord.id];
            localizations.push(newRecord);
            return setState({ localizations });
          },
          onRowUpdate: (newRecord: hb.GenericRecord, oldRecord: hb.GenericRecord) => {
            newRecord.name = allLocalizations[newRecord.id];
            const index = localizations.indexOf(oldRecord);
            localizations[index] = newRecord;
            return setState({ localizations });
          },
          onRowDelete: (oldRecord: hb.GenericRecord) => {
            const index = localizations.indexOf(oldRecord);
            localizations.splice(index, 1);
            return setState({ localizations });
          },
        }
      }
      options={{
        actionsColumnIndex: -1,
        emptyRowsWhenPaging: false,
        showTitle: false,
        paging: false,
        addRowPosition: 'first',
      }}
    />
  );
};

export default LocalizationTable;
